// S&P 500 universe grouped by GICS sector.
// All members have liquid listed options (all 500 do).
// Subset selected for liquidity and options depth.

export const SP500 = {
  "Information Technology": [
    "AAPL","MSFT","NVDA","AVGO","ORCL","CRM","AMD","CSCO","ADBE","TXN",
    "QCOM","INTU","IBM","MU","AMAT","LRCX","ADI","KLAC","MCHP","ACN",
  ],
  "Health Care": [
    "LLY","UNH","JNJ","ABBV","MRK","TMO","ABT","BMY","AMGN","PFE",
    "ELV","CVS","CI","SYK","ISRG","BSX","MDT","ZTS","REGN","VRTX",
  ],
  "Financials": [
    "JPM","BAC","WFC","GS","MS","BLK","C","AXP","SPGI","MCO",
    "CB","USB","TFC","PNC","AIG","MMC","AON","PRU","MET","AFL",
  ],
  "Consumer Discretionary": [
    "AMZN","TSLA","HD","MCD","NKE","LOW","SBUX","TGT","BKNG","CMG",
    "ORLY","AZO","ROST","TJX","DHI","LEN","GM","F","EXPE","RCL",
  ],
  "Communication Services": [
    "META","GOOGL","NFLX","DIS","CMCSA","T","VZ","TMUS","WBD","PARA",
    "IPG","OMC","MTCH","EA","TTWO","LYV","FOX","FOXA","IAC","NWSA",
  ],
  "Industrials": [
    "GE","CAT","RTX","HON","UNP","BA","DE","LMT","ETN","UPS",
    "WM","EMR","ITW","PH","ROK","FDX","CSX","NSC","PCAR","IR",
  ],
  "Consumer Staples": [
    "WMT","PG","KO","PEP","COST","MO","PM","CL","GIS","KHC",
    "STZ","MDLZ","EL","HSY","CHD","CLX","SJM","CAG","CPB","MKC",
  ],
  "Energy": [
    "XOM","CVX","COP","EOG","SLB","MPC","PSX","VLO","OXY","DVN",
    "HES","HAL","BKR","TRGP","KMI","WMB","OKE","LNG","PXD","FANG",
  ],
  "Materials": [
    "LIN","APD","SHW","FCX","NEM","ECL","DD","PPG","ALB","CF",
    "MOS","NUE","STLD","RS","VMC","MLM","PKG","IP","WRK","SEE",
  ],
  "Real Estate": [
    "PLD","AMT","EQIX","CCI","PSA","O","WELL","SPG","DLR","AVB",
  ],
  "Utilities": [
    "NEE","DUK","SO","D","AEP","XEL","ED","ETR","PPL","FE",
  ],
};

export const SECTORS = Object.keys(SP500);
export const ALL_TICKERS = Object.values(SP500).flat();

export function findSectorForTicker(ticker) {
  for (const [sector, tickers] of Object.entries(SP500)) {
    if (tickers.includes(ticker)) return sector;
  }
  return null;
}
